// extracted by mini-css-extract-plugin
export default {"statisticsWSrapper_title":"statisticsWrapper_statisticsWSrapper_title__VgcDC"};